// libs
import React from 'react';
// components
import { default as BaseRadio } from '@mui/material/Radio';
import c from 'classnames';

import Box from '../Box';
// styles
import { radioIcon, radioOverrides } from './styles';
// types
import { RadioProps, RadioSize } from './types';

const radioUnCheckedIcon = (size: RadioSize) => (
  <Box
    className={c(
      'outer-circle bg-transparent rounded-full border border-solid border-border group-hover:border-border-dark',
      radioIcon(size),
    )}
  />
);

const radioCheckedIcon = (size: RadioSize) => (
  <Box
    className={c(
      'outer-circle bg-transparent rounded-full border-2 border-solid border-interactive-primary relative group-hover:border-interactive-primary-hover',
      radioIcon(size),
    )}>
    <Box className="inner-circle bg-interactive-primary rounded-full absolute top-1/2 start-1/2 transform -translate-x-1/2 rtl:translate-x-1/2 -translate-y-1/2 group-hover:bg-interactive-primary-hover" />
  </Box>
);

function Radio(props: RadioProps) {
  const { className, size = 'medium', ...rest } = props;
  return (
    <BaseRadio
      className={c('group p-0', radioOverrides, className)}
      {...rest}
      checkedIcon={radioCheckedIcon(size)}
      icon={radioUnCheckedIcon(size)}
    />
  );
}

export default React.memo(Radio);
